// import logo from "../../images/logo.png";

import Features from "./Features";
import Navbar from "../Sections/NavBar";
import Welcome from "./Welcome";

function Home() {
  return (
    <>
      <Navbar />
      <Welcome />
      <Features />
    </>
  );
}

export default Home;
